<template>
    <BasicModalWindow @modalWindowClose="close()"
      ref="modal_delete"
      class="small-window contacts-delete"
      :content_state="content_state"
      :title="props.title"
    >
        <template #body>
           <slot name="modal_body"></slot>
        </template>

        <template #footer>
            <ActionButton v-if="show_cancel"
              @click="close()"
              :text="text_cancel"
            />

            <ActionButton v-if="show_revert"
              @click="revert()"
              class="revert"
              :text="text_revert"
            />

            <ActionButton
              @click="confirm()"
              :class="[
                confirm_class,
                'push-right',
              ]"
              :text="text_confirm"
              :loading="content_state.saving_inline"
            />
        </template>
    </BasicModalWindow>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';
  import BasicModalWindow             from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue'
  import ContentState                 from '@/js/Shared/State/ContentState';

  const emit  = defineEmits([
    'actionConfirm',
    'actionCancel',
    'actionRevert',
  ]);

  const props = defineProps({
    title : {
      default: 'global.actions.warning',
    },

    text_cancel : {
      default: 'global.actions.cancel',
    },

    text_confirm : {
      default: 'global.actions.confirm',
    },

    text_revert : {
      default: 'global.actions.revert',
    },

    content_state : {
      default: new ContentState(),
    },

    show_cancel : {
      default : true,
    },

    show_revert : {
      default : false,
    },

    confirm_class : {
      default : 'main-action',
    }
  });

  const revert = () => {
    emit('actionRevert');
  }

  const confirm = () => {
    emit('actionConfirm');
  }

  const close = () => {
    emit('actionCancel');
  }
</script>
